module.exports = "/fast-coin/img/coin/anim/out_1/out_1_007.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/out_1/out_1_007.png
// module id = 2303
// module chunks = 5